import { useCallback } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import {
  DISPLAY_NAME,
  type ScopedProps,
  useCardInformativeContext,
} from '../../card-informative'
import * as C from './card-informative.icon.styles'

type CardInformativeIconProps = {}

export const CardInformativeIcon = (props: CardInformativeIconProps) => {
  const { __scopeCardInformative } =
    props as ScopedProps<CardInformativeIconProps>
  const { iconName, variants, type } = useCardInformativeContext(
    DISPLAY_NAME,
    __scopeCardInformative
  )

  const mapper: Record<typeof variants, TIconProps['color']> = {
    positive: 'colorTextSuccessAlternative',
    informative: 'colorTextInformativeAlternative',
    warning: 'colorTextWarningAlternative',
    negative: 'colorTextDangerAlternative',
    neutral: 'colorTextNeutralAlternative',
  }

  const mapVariantColor = useCallback((): TIconProps['color'] => {
    return mapper[variants]
  }, [variants])

  return (
    <C.Container type={type} testID="card-informative-icon">
      <Icon symbol={iconName} size="small" color={mapVariantColor()} />
    </C.Container>
  )
}
